/**
 * Checks whether the state object meets the expectedConditionsObject, e.g. let's say
 * the state is {swRegistered:true,authenticated:false} and the expectedConditionsObject is
 *              {swRegistered:false, authenticated:false}
 * In this  case the function will return false as not all expectedConditions are fulfilled.
 * @param {*} state
 * @param {*} expectedConditionsObject
 */
export function preconditionsMet(state, expectedConditionsObject) {
  let matchedAllTrueAttributes = true;
  Object.keys(expectedConditionsObject).forEach((attribute) => {
    if (expectedConditionsObject[attribute] === true) {
      if (state[attribute] !== true) matchedAllTrueAttributes = false;
      // accept also false because we start with the strongest conditions and if one property is better than
      // expected we are glad
    }
  });
  //console.debug('matchedAllTrueAttributes', matchedAllTrueAttributes);
  return matchedAllTrueAttributes;
}

/**
 * Detect the phase the application is in.
 * If this function should be refactored, the condition checks need to
 * keep the same order (later phases first)
 * @param {*} state
 */
export function detectAppPhase(state, isPwaMode, PHASES) {
  const checkPhases = [PHASES.ready, PHASES.authenticated, PHASES.login, PHASES.bootstrapping, PHASES.onStartup];
  const pwaMode = isPwaMode ? 'pwa' : 'nonPwa';
  let { preCacheLoaded, swRegistered, isDefaultLanguageLoaded, configsLoaded, isLanguageLoaded, authenticated, isModuleConfigsProcessed } = state;
  console.debug(
    'detectPhase pwaMode',
    pwaMode,
    JSON.stringify(
      {
        preCacheLoaded,
        swRegistered,
        isDefaultLanguageLoaded,
        configsLoaded,
        isLanguageLoaded,
        authenticated,
        isModuleConfigsProcessed,
      },
      null,
      2
    )
  );
  for (let i = 0; i < checkPhases.length; i++) {
    if (preconditionsMet(state, checkPhases[i].preConditions[pwaMode])) {
      console.debug(`Detected phase "${checkPhases[i].name}`, JSON.stringify(checkPhases[i].preConditions, null, 2));

      return checkPhases[i];
    }
  }
  console.debug(`unknown app phase state detected (no phase transition), due to the following states`);
  logAppState(state);
  return PHASES.unknown;
}

export function logAppState({
  authenticated,
  configsLoaded,
  swRegistered,
  preCacheLoaded,
  isModuleConfigsProcessed,
  isDefaultLanguageLoaded,
  isLanguageLoaded,
  logMsg,
  forceLogging = true,
}) {
  forceLogging = true;
  if (forceLogging)
    console.debug(
      `setAppStates: ${logMsg ? `${logMsg}.` : ''} Set properties ${JSON.stringify({
        authenticated,
        configsLoaded,
        swRegistered,
        preCacheLoaded,
        isModuleConfigsProcessed,
        isDefaultLanguageLoaded,
        isLanguageLoaded,
      })}`
    );
}
